import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #fff;
  font-family: "Euclid Circular B";
`;

export const Title = styled.div`
  color: var(--Text-Primary, #040222);
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  transform: rotate(-0.007deg);
  align-self: stretch;
  margin-bottom: 20px;
  margin-top:8px;
`;

export const TimelineList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TimelineItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  position: relative;
`;

export const IconWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  padding-top: 2px;
`;

export const ConnectorLine = styled.div<{ isCompleted: boolean }>`
  width: 1.25px;
  height: 45px;
  background-color: ${(props) =>
    props.isCompleted ? "#219653" : "#E7E7F0"};
  margin-top: 4px;
  flex-shrink: 0;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  padding-bottom: 12px;
`;

export const StatusText = styled.div`
  color: var(--text-primary-n-600, #040222);
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
`;

export const DateTimeText = styled.div`
  color: var(--text-secondary-n-400, #5b5675);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

export const MarkAsDeliveredPrompt = styled.div`
  color: var(--Text-Secondary, #5b5675);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

export const MarkAsDeliveredLink = styled.button`
  display: inline;
  width: fit-content;
  padding: 0;
  border: none;
  background: none;
  color: var(--button-hyperlink-b-300, #1b73e8);
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
  text-decoration: none;
  cursor: pointer;

  &:disabled {
    color: #9b97b0;
    cursor: not-allowed;
  }
`;

export const SeparatorLine = styled.div`
  width: auto;
  height: 1px;
  background: #E7E7F0;
  margin-left: 32px;
  margin-top: 4px;
  margin-bottom: 4px;
`;

